<template>
  <div class="viewport" v-resize:debounce.150="onResize">
    <canvas class="layer3D"></canvas>
    <div class="layer2D"><slot></slot></div>
  </div>
</template>

<script>
import { WebGLRenderer, PerspectiveCamera, Scene, Vector3, Clock } from 'three'
import { RenderPass, EffectComposer, EffectPass } from 'postprocessing'
import resize from 'vue-resize-directive'
import OrbitControls from 'three-orbitcontrols'

export default {
  name: 'WebGLCanvas',
  directives: {
    resize
  },
  data () {
    return {
      width: 0,
      height: 0
    }
  },
  mounted () {
    this.scene = new Scene()
    this.camera = new PerspectiveCamera()
    this.clock = new Clock()
    this.renderer = new WebGLRenderer({ canvas: this.$el.getElementsByTagName('canvas')[ 0 ], antialias: true })
    this.camera.position.set(30, 30, -50)
    this.renderer.setPixelRatio(window.devicePixelRatio)
    this.renderer.setClearColor(0x000000, 1)
    this.composer = new EffectComposer(this.renderer)
    this.renderPass = new RenderPass(this.scene, this.camera)
    this.renderPass.renderToScreen = true
    this.composer.addPass(this.renderPass)
    this.onResize()
    this.controls = new OrbitControls(this.camera, this.$el.domElement)
    this.controls.target = new Vector3(0, 20, 0)
    this.camera.lookAt(new Vector3(0, 20, 0))
    requestAnimationFrame(this.loop)
  },
  methods: {
    loop (timeStamp) {
      // this.renderer.render(window.scene, this.camera)
      this.composer.render(this.clock.getDelta())
      this.$emit('on-animation-frame', timeStamp)
      requestAnimationFrame(this.loop)
    },
    onResize () {
      console.log('resize ' + this.$el.offsetWidth + ' ' + this.$el.offsetHeight)
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetHeight
      this.camera.aspect = this.width / this.height
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.width, this.height)
      this.composer.setSize(this.width, this.height)
    },
    addObject (o) {
      this.scene.add(o)
    },
    addEffect (effect) {
      var pass = new EffectPass(this.camera, effect)
      this.renderPass.renderToScreen = false
      pass.renderToScreen = true
      this.composer.addPass(pass)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .layer2D, .viewport {
  width: 100%;
  height: 100%;
  position: relative;
}
.layer3D {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

</style>
